
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 10h-4.5a1 1 0 01-1-1V4.5H7v15h10V10zm-1.192-2L13.5 5.82V8h2.308zM6 2.5h6.5a1 1 0 01.687.273l5.5 5.194a1 1 0 01.313.727V20.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-17a1 1 0 011-1z"}})])
          )
        }
      }
    